import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ArrowUpIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { BVLogo } from './BVLogo';
const quickLinks = [{
  label: 'Home',
  href: '#'
}, {
  label: 'Our Restaurants',
  href: '#businesses'
}, {
  label: 'About Us',
  href: '#'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#1d1d1f] text-white" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 py-20" data-id="element-93">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-24" data-id="element-94">
          {/* Brand */}
          <div data-id="element-95">
            <div className="mb-6" data-id="element-96">
              <BVLogo size={72} darkBackground data-id="element-97" />
            </div>
            <p className="text-[#86868b] text-[16px] leading-relaxed mb-8 max-w-sm" data-id="element-98">
              {t.footer.description}
            </p>

            {/* Social Links */}
            <div className="flex gap-4" data-id="element-99">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#c9a961] hover:text-black transition-all duration-300" data-id="element-100">
                <InstagramIcon className="w-5 h-5" data-id="element-101" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#c9a961] hover:text-black transition-all duration-300" data-id="element-102">
                <FacebookIcon className="w-5 h-5" data-id="element-103" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-104">
            <h4 className="font-display text-[20px] text-white mb-8" data-id="element-105">
              {t.footer.quickLinks}
            </h4>
            <ul className="space-y-4" data-id="element-106">
              {quickLinks.map(link => <li key={link.label} data-id="element-107">
                  <a href={link.href} className="text-[#86868b] text-[15px] hover:text-[#c9a961] transition-colors duration-300 flex items-center gap-2 group" data-id="element-108">
                    <span className="w-0 group-hover:w-4 h-[1px] bg-[#c9a961] transition-all duration-300" data-id="element-109" />
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-110">
            <h4 className="font-display text-[20px] text-white mb-8" data-id="element-111">
              {t.footer.contact}
            </h4>
            <ul className="space-y-6" data-id="element-112">
              <li className="flex items-start gap-4 group" data-id="element-113">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-[#c9a961]/20 transition-colors duration-300" data-id="element-114">
                  <MapPinIcon className="w-5 h-5 text-[#c9a961]" data-id="element-115" />
                </div>
                <span className="text-[#86868b] text-[15px] leading-relaxed group-hover:text-white transition-colors duration-300" data-id="element-116">
                  629, Phetchburi 31 Road, Makassan, Ratchathewi, Bangkok 10400
                </span>
              </li>
              <li className="flex items-center gap-4 group" data-id="element-117">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-[#c9a961]/20 transition-colors duration-300" data-id="element-118">
                  <MailIcon className="w-5 h-5 text-[#c9a961]" data-id="element-119" />
                </div>
                <a href="mailto:bvgroupthailand@gmail.com" className="text-[#86868b] text-[15px] hover:text-white transition-colors duration-300" data-id="element-120">
                  bvgroupthailand@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-4 group" data-id="element-121">
                <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0 group-hover:bg-[#c9a961]/20 transition-colors duration-300" data-id="element-122">
                  <PhoneIcon className="w-5 h-5 text-[#c9a961]" data-id="element-123" />
                </div>
                <a href="tel:+66811770305" className="text-[#86868b] text-[15px] hover:text-white transition-colors duration-300" data-id="element-124">
                  +66 811 770 0305
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 bg-black" data-id="element-125">
        <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-126">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[#86868b] text-[13px] tracking-wide" data-id="element-127">
            <p data-id="element-128">{t.footer.rights}</p>
            <div className="flex items-center gap-6" data-id="element-129">
              <p data-id="element-130">{t.footer.design}</p>
              <button onClick={scrollToTop} className="w-10 h-10 border border-white/10 flex items-center justify-center hover:bg-[#c9a961] hover:text-black hover:border-[#c9a961] transition-all duration-300" aria-label="Scroll to top" data-id="element-131">
                <ArrowUpIcon className="w-4 h-4" data-id="element-132" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}